import { render, staticRenderFns } from "./SkinManualScania.vue?vue&type=template&id=a77adc36&"
import script from "./SkinManualScania.vue?vue&type=script&lang=js&"
export * from "./SkinManualScania.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports